// BusStopManager component for managing bus stop entries

import React, { useMemo, useState, useEffect } from 'react';
import SearchableSelect from '../common/SearchableSelect';
import { getBusStops } from '../../services/api';

const BusStopManager = ({ busStops, onChange }) => {
  const [busStopOptions, setBusStopOptions] = useState([]);

  // Load bus stop data from API
  useEffect(() => {
    const loadBusStops = async () => {
      try {
        const result = await getBusStops();
        
        if (result.success && result.data) {
          // Convert string array to {value, label} format for SearchableSelect
          const formattedOptions = result.data.map((name) => ({
            value: name,
            label: name,
          }));
          setBusStopOptions(formattedOptions);
        } else {
          console.error('Failed to load bus stops:', result.error);
          setBusStopOptions([]);
        }
      } catch (error) {
        console.error('Error loading bus stops:', error);
        setBusStopOptions([]);
      }
    };
    
    loadBusStops();
  }, []);
  const addBusStop = () => {
    onChange([...busStops, { name: '', passengers: '' }]);
  };

  const removeBusStop = (index) => {
    const newBusStops = busStops.filter((_, i) => i !== index);
    onChange(newBusStops);
  };

  const updateBusStop = (index, field, value) => {
    const newBusStops = [...busStops];
    newBusStops[index] = {
      ...newBusStops[index],
      [field]: value,
    };
    onChange(newBusStops);
  };

  return (
    <div className="md:col-span-2 lg:col-span-3">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        ข้อมูลป้ายจอดรถที่สนใจ
      </label>
      <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
        <div className="space-y-3">
          {busStops.map((stop, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-fade-in"
            >
              <div>
                <SearchableSelect
                  value={stop.name}
                  onChange={(value) => updateBusStop(index, 'name', value)}
                  options={busStopOptions}
                  placeholder="เลือกชื่อป้ายจอดรถ"
                  allowCustom={true}
                />
              </div>
              <div className="flex gap-2">
                <input
                  type="number"
                  placeholder="จำนวนผู้โดยสาร"
                  min="0"
                  value={stop.passengers}
                  onChange={(e) =>
                    updateBusStop(index, 'passengers', e.target.value)
                  }
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {busStops.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeBusStop(index)}
                    className="text-red-600 hover:text-red-800 p-2 rounded transition-colors"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addBusStop}
          className="mt-3 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center text-sm"
        >
          <svg
            className="w-4 h-4 mr-2"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
              clipRule="evenodd"
            />
          </svg>
          เพิ่มป้ายจอดรถ
        </button>
      </div>
    </div>
  );
};

export default BusStopManager;
